import { render, staticRenderFns } from "./ProductDetailsTitle.vue?vue&type=template&id=0c524a94"
import script from "./ProductDetailsTitle.vue?vue&type=script&lang=ts"
export * from "./ProductDetailsTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports